import { render, staticRenderFns } from "./AllClassify.vue?vue&type=template&id=a81421e0&scoped=true&"
import script from "./AllClassify.vue?vue&type=script&lang=js&"
export * from "./AllClassify.vue?vue&type=script&lang=js&"
import style0 from "./AllClassify.vue?vue&type=style&index=0&id=a81421e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81421e0",
  null
  
)

export default component.exports